import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useCreateAnnouncement () {
  const queryClient = useQueryClient()

  return useMutation(
    async (values) => {
      const newAnnouncement = await axios.post(`${getApiServer()}/announcements`, values, { withCredentials: true })
      return newAnnouncement.data
    },
    {
      onMutate: (values) => {
        const oldAnnouncements = queryClient.getQueryData('announcements')
        const announcement = {
          Description: values.description,
          EndDate: values.endDate,
          Link: values.link,
          Title: values.title
        }
        queryClient.setQueryData('announcements', [announcement, ...oldAnnouncements])
      },
      onSuccess: async () => {
        await queryClient.refetchQueries('announcements')
      }
    }
  )
}